// extracted by mini-css-extract-plugin
module.exports = {"checkbox-group":"_99551c8aa8--checkbox-group--FYaOT"};